import React, {PureComponent} from 'react'
import injectSheet from 'react-jss'
import cn from 'classnames'
import RichTextContainer from "../Widgets/RichTextContainer"
import Link from "../Widgets/Link"
import ImageOrVideo from "../Widgets/ImageOrVideo"
import theme from "../../styles/theme"

class Advert extends PureComponent {
  render() {
    const { classes, classNames = {}, image, contentOrder, alignCopy, title, heading, text, buttonLink, showHeading = false, buttonSize = "small" } = this.props;
    return (
      <div className={cn(classes.container, classNames.container, contentOrder === 'Reverse' && classes.reverse, image && classes.hasImage)}>
        { image && (
          <div className={cn(classes.imageContainer, classNames.imageContainer)}>
            <ImageOrVideo images={image} link={buttonLink} />
          </div>
        ) }
        <div className={cn(classes.copy)}>
          { showHeading && heading && <h6 className={classes.heading}>{ heading }</h6> }
          <div className={cn(classes.content, classNames.content, heading && 'hasHeading', {
            [classes.alignLeft]: alignCopy === "Left",
            [classes.alignCenter]: alignCopy === "Center",
            [classes.alignRight]: alignCopy === "Right",
          })}>
            { title && <h4 className={classes.title}>{ title }</h4> }
            { text && <RichTextContainer className={classes.text} key="content" content={text} /> }
            { buttonLink && buttonLink.url && <Link link={buttonLink} className={classes.button} size={buttonSize}>{buttonLink.label}</Link> }
          </div>
        </div>
      </div>
    )
  }
}

export default injectSheet(
  {
    container: {
      [theme.breakpoint("tablet")]: {
        display: 'flex',
        flexDirection: 'row'
      }
    },
    reverse: {
      flexDirection: 'row-reverse'
    },
    hasImage: {
      borderLeft: '1px solid #B0B0B0',
      borderRight: '1px solid #B0B0B0',
    },
    imageContainer: {
      width: '100%',
      [theme.breakpoint("tablet")]: {
        display: 'flex',
        flex: 1,
        flexBasis: '50%',
        '& > div': {
          display: 'flex',
          flex: 1
        }
      }
    },
    copy: {
      display: 'block',
      textAlign: 'center',
      width: '100%',
      [theme.breakpoint("tablet")]: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        flexBasis: '50%',
      }
    },
    content: {
      padding: ['2rem', '1.5rem', '1.5rem'],
      '&.hasHeading': {
        padding: ['1.5rem', '3rem', '1.5rem'],
      },
      [theme.breakpoint("tablet")]: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        flex: 1,
        padding: ['2rem', '3rem'],
        '&.hasHeading': {
          padding: ['1.75rem', '3rem', '2rem'],
        }
      }
    },
    alignLeft: {
      textAlign: 'left',
      alignItems: 'flex-start',
    },
    alignCenter: {
      textAlign: 'center',
      alignItems: 'center',
    },
    alignRight: {
      textAlign: 'right',
      alignItems: 'flex-end',
    },
    heading: {
      fontFamily: theme.font.family,
      fontSize: 10,
      color: theme.colors.faintGrey,
      letterSpacing: 0.26,
      textAlign: 'center',
      lineHeight: 1,
      textTransform: 'uppercase',
      margin: ['1rem', 0, 0, 0],
      padding: [0, '2rem'],
    },
    title: {
      fontSize: '1.2rem',
      letterSpacing: '-0.3px',
      lineHeight: '1.8rem',
      marginBottom: 5,
    },
    text: {
      '& > p': {
        marginBottom: '0.5rem',
        fontSize: '1rem',
        lineHeight: 1.5
      }
    }
  }
)(Advert)



// WEBPACK FOOTER //
// ./src/components/Article/Advert.js